import { render, staticRenderFns } from "./RevokeModalNotAllowed.vue?vue&type=template&id=3b274102"
import script from "./RevokeModalNotAllowed.vue?vue&type=script&lang=js"
export * from "./RevokeModalNotAllowed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports